import React, { useEffect } from "react";

const GoogleTranslate = () => {
  const googleTranslateElementInit = () => {
    new window.google.translate.TranslateElement(
      {
        pageLanguage: "en",
        autoDisplay: false,
      },
      "google_translate_element",
    );
  };
  useEffect(() => {
    var addScript = document.createElement("script");
    addScript.setAttribute(
      "src",
      "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit",
    );
    document.body.appendChild(addScript);
    window.googleTranslateElementInit = googleTranslateElementInit;
  }, []);

  return (
    <>
      <div id="google_translate_element" className="googleTranslate"></div>
      <style>{`
            .googleTranslate .goog-te-gadget{
                color: transparent !important;
            }
            .googleTranslate .goog-te-gadget span {
                display: none !important;
            }
            .googleTranslate .goog-te-gadget span a {
                display: none !important;      
            }
            .goog-te-combo{
              padding: 8px;
              border-radius: 8px;
              color: var(--text-primary);
              background: var(--theme-light-bgcolor);
              border: 2px solid var(--border-color);
              cursor: pointer;
              transition: all 0.3s ease;
              font-size: 14px;
            }
            .goog-te-combo:hover {
              border-color: var(--primary-purple);
            }
            .goog-te-combo option {
              background: var(--theme-light-bgcolor);
              color: #020618;
            }
            .goog-te-gadget-simple {
              background-color: transparent !important;
              border: none !important;
            }
            .goog-te-gadget-icon {
              display: none !important;
            }
            .goog-logo-link {
              display: none !important;
            }
            .goog-te-banner-frame {
              display: none !important;
            }
        `}</style>
    </>
  );
};

export default GoogleTranslate;
